module.exports = __webpack_public_path__ + "static/media/kk.a3d9a6cc.png";